import { IFinancialCockpitQbrDocument } from '../../api/types'

export const canDownloadQbrPptx = (
  document: Pick<IFinancialCockpitQbrDocument, 'PPTXReport' | 'UID'>
): boolean => Boolean(document.PPTXReport && document.UID)
